export const QUICK_CHAT_RECENT_WINDOW_MS = 72 * 60 * 60 * 1000;

export function parseTicketUpdatedAt(updatedAt) {
  if (updatedAt == null || updatedAt === "") return 0;
  const asNumber = Number(updatedAt);
  if (!Number.isNaN(asNumber) && asNumber > 0) return asNumber;
  const parsed = new Date(updatedAt).getTime();
  return Number.isNaN(parsed) ? 0 : parsed;
}

export function getQuickChatTicketTitle(ticket) {
  return ticket?.title?.trim() || `گفت‌وگو #${ticket?.id ?? ""}`;
}

/**
 * Returns the most recently updated ticket within the given window, or null.
 */
export function findRecentChatWithin72Hours(tickets, windowMs = QUICK_CHAT_RECENT_WINDOW_MS) {
  if (!Array.isArray(tickets) || !tickets.length) return null;

  const cutoff = Date.now() - windowMs;
  let best = null;
  let bestTime = 0;

  tickets.forEach((ticket) => {
    const updatedAt = parseTicketUpdatedAt(ticket?.updated_at);
    if (updatedAt >= cutoff && updatedAt > bestTime) {
      best = ticket;
      bestTime = updatedAt;
    }
  });

  return best;
}
